/**
 * usePageTitle — Tiny hook that synchronises `document.title` with the
 * caller-provided value while the component is mounted, and restores
 * the default Realty237 title on unmount.
 *
 * Why this hook instead of react-helmet?
 *  • Zero deps (we already depend on react-router-dom)
 *  • Hook runs after commit so the title change reflects the post-fetch
 *    state (e.g. "Villa Moderne à Bonapriso | 85M FCFA | Realty237"
 *    once the property data arrives)
 *  • The cleanup callback prevents stale titles when the user navigates
 *    away (e.g., from /property/X to /about)
 *
 * Usage:
 *   usePageTitle('À propos | Realty237');
 *   usePageTitle(property ? `${property.title} | ${fmtPrice} | Realty237` : '');
 *   // Empty string / null / undefined → hook is a no-op (lets parent
 *   // pages keep their own default).
 */
import { useEffect } from 'react';

const DEFAULT_TITLE = 'Realty237 — Trouvez votre espace';

export default function usePageTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => { document.title = previous || DEFAULT_TITLE; };
  }, [title]);
}
